import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Compass } from 'lucide-react';
import { EmptyState } from './EmptyState';

/**
 * LOK-1126: shown when a route doesn't match anything in the router. Replaces
 * the previous catch-all `<Navigate to="/" replace />`, which silently dropped
 * users on the landing page when an internal link was stale.
 */
export function NotFoundPage() {
  const { t } = useTranslation('common');
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="mx-auto max-w-2xl py-16">
      <EmptyState
        variant="zero"
        icon={Compass}
        title={t('notFound.title')}
        description={t('notFound.description', { path: location.pathname })}
        primaryCTA={{
          label: t('notFound.backToDashboard'),
          onClick: () => navigate('/dashboard'),
        }}
      />
    </div>
  );
}

export default NotFoundPage;
